import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { util } from './util.js'
Vue.prototype.$util = util

//Vue.config.productionTip = false

/* import * as VueGoogleMaps from 'vue2-google-maps'
// para usarse hay que añadir en package-json
//"vue2-google-maps": "^0.10.7",
//
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCs1ppuEIyf_rZilM7Quovw77n-OnxhaAo',
    // libraries: 'places',
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
}) */

/* Vue.filter("NS", (N) => {
  return (N==0 ? "" : util.NS(Number(N)));
}) */

Vue.filter("fecha", (N, tipo= "sql2visual") => {
  if (!window.Intl) return N;
  if (N== "" || N==null) return N;

  if (tipo== "sql2visual") {
    let p = N.split("-");

    if (p[1].length) p[1] = String(p[1].padStart(2, "0"));
    if (p[0].length) p[0] = String(p[0].padStart(2, "0"));
    return [p[2], p[1], p[0]].join('/');
  }

  if (tipo == "visual2sql") {
    let p = N.split(/\D/g);
    return [p[2], p[1], p[0]].join("-");
  }

  return N;
})

Vue.directive('uppercase', {
  bind(el) {
    el.addEventListener('keyup', () => {
      el.value = el.value.toUpperCase();
    })
  }
})

Vue.directive('numericOnly', {
  bind(el) {
    el.addEventListener('keyup', () => {
      let regex = /^[0-9]*$/
      if (!regex.test(el.value)) {
        el.value = el.value.slice(0, -1)
      }
    })
  }
})

Vue.directive('numero', {
  bind(el) {
    el.addEventListener('keyup', (e) => {
      if (e.key<'0' || e.key>'9') el.value = el.value.slice(0, -1);
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
